import React from "react";
import { useTranslation } from "react-i18next";
import TextEditor from "@/components/controls/TextEditor/TextEditor";
import { getPlaceholder } from "../shared";
import { asString, ControlProps } from "../types";

export const TextareaControl: React.FC<ControlProps> = ({
  fieldType,
  value,
  onChange
}) => {
  const { t } = useTranslation();

  return (
    <div className="w-full min-w-0">
      <TextEditor
        value={asString(value)}
        onBlur={(next: string) => onChange(next)}
        placeholder={getPlaceholder(fieldType, t)}
        variant="form"
      />
    </div>
  );
};
